module.exports = __webpack_public_path__ + "img/20.09375032.jpg";